import React from "react";
import "./index.css";
import TreeNode from "./DataObjectTreeNodeChild";
import styles from "./TreeMapFile.module.css";

const Tree = ({
  data = [],
  showMapButton,
  setShowMapButton,
  createNewElement,
  setDeLinkState,
  isWS,
  setSelectedContent,
  dataRef,
  setSelectedControl,
  selectedControl,
  mappedServiceRef,
  openModifyDataObjMf = () => {
    console.log("provide Modify Mf fn");
  },
  portalState,
}) => {
  return (
    <div className="d-tree">
      <ul className="d-flex d-tree-container flex-column">
          {data.map((tree) => (
            <>
              <TreeNode
                node={tree}
                key={tree["VariableName"]}
                showMapButton={showMapButton}
                setShowMapButton={setShowMapButton}
                createNewElement={createNewElement}
                isWS={isWS}
                setDeLinkState={setDeLinkState}
                setSelectedContent={setSelectedContent}
                dataRef={dataRef}
                setSelectedControl={setSelectedControl}
                selectedControl={selectedControl}
                mappedServiceRef={mappedServiceRef}
                openModifyDataObjMf={openModifyDataObjMf}
                portalState={portalState}
              />
            </>
          ))}
      </ul>
    </div>
  );
};

export default Tree;
